import { Component } from '@angular/core';

@Component({
    selector: 'checkbox',
    templateUrl: 'checkbox.html',
    styleUrls: ['../field-abstract/icon-field.scss', 'checkbox.scss']
})
export class CheckboxComponent {}
